import React from 'react';
import { Link } from 'react-router-dom';
import MapleLeaf from '../components/MapleLeaf';
import { COMMUNITIES } from './shared';

// The national job search's own frame (GROWTH-004): a dark "ink" header and footer on warm paper,
// deliberately unlike the five boards (white pages in each board's colour).
export const INK = '#0b1220';

export function JobsHeader() {
  return (
    <header className="border-b border-white/10 text-white" style={{ backgroundColor: INK }}>
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link to="/jobs" className="flex items-center gap-2 whitespace-nowrap" aria-label="CanadaJobLeads jobs">
          <MapleLeaf className="h-7 w-7 text-primary" />
          <span className="font-[Poppins] text-lg font-semibold tracking-tight">
            CanadaJobLeads<span className="hidden text-white/50 sm:inline"> / jobs</span>
          </span>
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/jobs" className="hidden font-medium text-white/80 hover:text-white sm:inline">
            Find jobs
          </Link>
          <Link to="/" className="whitespace-nowrap rounded-full border border-white/30 px-3 py-1.5 font-semibold text-white hover:bg-white/10">
            For employers
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function JobsFooter() {
  return (
    <footer className="mt-16 text-sm text-white/70" style={{ backgroundColor: INK }}>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-10 sm:grid-cols-3 sm:px-6">
        <div>
          <p className="flex items-center gap-2 font-[Poppins] text-base font-semibold text-white">
            <MapleLeaf className="h-5 w-5 text-primary" /> CanadaJobLeads
          </p>
          <p className="mt-2">Jobs across Canada from employers hiring people who are often overlooked.</p>
        </div>
        <div>
          <p className="font-semibold text-white">Our community boards</p>
          <ul className="mt-2 space-y-1">
            {COMMUNITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/jobs?community=${c.slug}`} className="hover:text-white">
                  {c.label}
                </Link>{' '}
                <span className="text-white/40">· {c.site}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-semibold text-white">Employers</p>
          <ul className="mt-2 space-y-1">
            <li>
              <Link to="/" className="hover:text-white">
                Post a job
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-white">
                Terms &amp; privacy
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <p className="border-t border-white/10 px-4 py-4 text-center text-xs text-white/40">© {new Date().getFullYear()} CanadaJobLeads, a Vinara Software Co. product</p>
    </footer>
  );
}

export default function JobsLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col text-slate-900" style={{ backgroundColor: '#f6f3ee' }}>
      <JobsHeader />
      <div className="flex-grow">{children}</div>
      <JobsFooter />
    </div>
  );
}
